/* eslint-disable no-nested-ternary */
/* eslint-disable react/default-props-match-prop-types */
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Box,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { GridValidRowModel } from "@mui/x-data-grid";

type DlgProps = {
  open: boolean;
  contentText: string;
  contentText1?: string;
  reviewStatus?: string;
  checkBox: boolean;
  handleNo?: () => void;
  // handleRejectYes?: (str: string, arr?: Array<string>) => void;
  handleRejectYes?: () => GridValidRowModel;
  handlePublishYes?: () => GridValidRowModel;
  handleReviewerDelYes?: () => GridValidRowModel;
  handleReviewerAssignYes?: () => GridValidRowModel;
  handleOK?: () => void;
  handleYes?: (str: string) => void;
};

const Dlg = ({
  open,
  contentText,
  contentText1,
  reviewStatus,
  checkBox,
  handleNo,
  handleRejectYes,
  handlePublishYes,
  handleReviewerDelYes,
  handleReviewerAssignYes,
  handleOK,
  handleYes,
}: DlgProps) => {
  const [radio, setRadio] = useState("");
  const [checkArr, setCheckArr]: any = useState([]);
  const handleRejectBtnYes = () => {
    if (handleRejectYes) {
      handleRejectYes();
    }
    // if (handleRejectYes) {
    //   if (radio !== "") {
    //     checkArr.length > 0
    //       ? handleRejectYes(radio, checkArr)
    //       : alert("Please check the reason for rejection");
    //   } else {
    //     alert("Please check the step for rejection");
    //   }
    // }
  };

  const handlePublishBtnYes = () => {
    if (handlePublishYes) {
      handlePublishYes();
    }
  };
  const handleReviewerDelBtnYes = () => {
    if (handleReviewerDelYes) handleReviewerDelYes();
  };
  const handleReviewerAssignBtnYes = () => {
    if (handleReviewerAssignYes) handleReviewerAssignYes();
  };
  const handleBtnNo = () => {
    if (handleNo) {
      handleNo();
      setRadio("");
      setCheckArr("");
    }
  };

  const handleChangeRadio = (event: any) => {
    setRadio(event.target.value);
  };
  const handleChangeCheck = (event: any) => {
    const isChecked = event.currentTarget.checked;
    const checkValue = event.target.value;

    if (isChecked) {
      setCheckArr([...checkArr, checkValue]);
    } else {
      setCheckArr(checkArr.filter((e: any) => e !== checkValue));
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "y" || event.key === "Enter") {
      if (handleRejectYes) {
        console.log("handleRejectYes");
        handleRejectYes();
      } else if (handlePublishYes) {
        console.log("handlePublishYes");
        handlePublishYes();
      } else if (handleReviewerDelYes) {
        console.log("handleReviewerDelYes");
        handleReviewerDelYes();
      } else if (handleReviewerAssignYes) {
        console.log("handleReviewerAssignYes");
        handleReviewerAssignYes();
      } else if (handleOK) {
        console.log("handleOK");
        handleOK();
      }
      // else if (handleYes) {
      //   console.log("handleYes");
      //   handleYes();
      // }
    } else if (event.key === "n" || event.key === "Escape") {
      handleBtnNo();
    }
  };

  return (
    <Dialog
      open={open}
      onKeyDown={handleKeyDown}
      PaperProps={{ id: "openedDlg" }}
    >
      <DialogContent>
        <Box>
          <DialogContentText>{contentText}</DialogContentText>
          {contentText1 && (
            <DialogContentText>{contentText1}</DialogContentText>
          )}
        </Box>
      </DialogContent>
      <Box
        sx={{
          mb: "24px",
          mr: "24px",
        }}
      >
        <DialogActions>
          {handleNo && (
            <Button onClick={handleBtnNo}>
              <b>
                <u>N</u>
              </b>
              O
            </Button>
          )}
          {handleRejectYes && (
            <Button onClick={handleRejectBtnYes}>
              <b>
                <u>Y</u>
              </b>
              ES
            </Button>
          )}
          {handlePublishYes && (
            <Button onClick={handlePublishBtnYes}>
              {" "}
              <b>
                <u>Y</u>
              </b>
              ES
            </Button>
          )}
          {handleReviewerDelYes && (
            <Button onClick={handleReviewerDelBtnYes}>
              {" "}
              <b>
                <u>Y</u>
              </b>
              ES
            </Button>
          )}
          {handleReviewerAssignYes && (
            <Button onClick={handleReviewerAssignBtnYes}>
              {" "}
              <b>
                <u>Y</u>
              </b>
              ES
            </Button>
          )}
          {handleOK && (
            <Button onClick={handleOK}>
              {" "}
              <b>
                <u>O</u>
              </b>
              K
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

Dlg.defaultProps = {
  open: false,
  contentText: "",
  checkBox: false,
};

export default Dlg;
